module.exports = __webpack_public_path__ + "static/media/weatherbuddy.c0a68ec0.PNG";